export const chartLineOptions = () => {
return {
    plugins: {
        legend: {
            display: false
        },
        layout: {
            padding: {
                bottom: 20
            }
        },
        title: {
            display: false
        },
        tooltip: {
            mode: 'index',
            intersect: false,
        },
        hover: {
            mode: 'index',
            intersect: false
        },

        annotation: {
            annotations: {
            }
        }

    },

    scales: {
        x: {},
        y: {
            offset: true
        }
    },

    responsive: true,
    maintainAspectRatio: false,
}}

export const chartBarOptions = () => {
    return {
        plugins: {
            legend: {
                display: false
            },
            layout: {
                padding: {
                    bottom: 20
                }
            },
            title: {
                display: false
            },
            tooltip: {
                enabled: true,
                mode: 'index',
                intersect: false,            
                filter: function ( item ) {
                    return !item.dataset.hasOwnProperty('hideTooltip') && item.raw !== null;    //gjrазываем только для первого datasource -
                }
            },
            hover: {
                mode: 'index',
                intersect: false
            },
        },

        scales: {
            x: {},
            y: {}
        },

        responsive: true,
        maintainAspectRatio: false,
        minBarLength: 3
    }
}

export const chartPolarOptions = {
    plugins: {
        legend: {
            display: false,
        },
        tooltip: {
            enabled: true,
            caretSize: 10,
            backgroundColor: 'rgba(0, 0, 55, 0.5)',
            callbacks: {
                label: function(context) {
                    return context.dataset.label;
                }
            }
        }
    },
    scales: {
        r: {
            startAngle: -11.25,
            angleLines: {
                display: true,
                lineWidth: 1,
                borderDash: [6, 8]
            },
            grid: {
                lineWidth: 1
            },
            ticks: {
                color: "rgb(180, 180, 180)",
                backdropColor: "rgba(0,0,0,0)",
                stepSize: 5,
                font: {
                    size: 12
                },
                z: 1,
                callback: function (value, index) {
                    return value + '%';
                }
            },
            pointLabels: {
                display: true,
                centerPointLabels: true,
                font: {
                    size: 12
                },
                callback: function (value, index) {
                    return value;
                    //if ((index % 2) === 0) return value;
                }
            }
        }

    }
}